<template>
  <div class="spinner-card" :data-message="loadingMessage">
    <div class="preloader-wrapper small active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
export default {
  name: 'dialogSpinner',
  props:{
    dataAlignment:{
      type: String,
    },
    loadingMessage:{
      type: String,
      default: 'Loading Please Wait..'
    }
  }
}
</script>
<style lang="scss" scoped>
.spinner-card {
  position: fixed;
  top: 50%;
  z-index: 99;
  background: white;
  padding: 16px;
  border-radius: 5px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.09),
              0 3px 1px -2px rgba(0, 0, 0, 0.08),
              0 1px 5px 0 rgba(0, 0, 0, 0.2);
  &::before {
    content: attr(data-message);
    position: absolute;
    left: 76px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>